import React, { useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { api } from '../../api/client';
import '../../styles/admin.css';

import { ta } from '../../i18n/adminT';
export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!token) {
      setError(ta('Link non valido: manca il token di reset.'));
      return;
    }
    if (newPassword.length < 8) {
      setError(ta('La nuova password deve avere almeno 8 caratteri.'));
      return;
    }
    if (newPassword !== confirmPassword) {
      setError(ta('La conferma non corrisponde alla nuova password.'));
      return;
    }

    setSubmitting(true);
    try {
      await api.resetPassword(token, newPassword);
      setSuccess(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-shell">
      <div className="auth-card">
        <div className="lock-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect x="5" y="10" width="14" height="10" rx="2" stroke="#F6F5F1" strokeWidth="1.8"/><path d="M8 10V7a4 4 0 018 0v3" stroke="#F6F5F1" strokeWidth="1.8"/></svg>
        </div>

        {!token ? (
          <>
            <h2>{ta('Link non valido')}</h2>
            <p className="modal-subtitle">{ta('Questo link di reset non è valido o è incompleto.')}</p>
            <Link to="/admin" className="btn btn-primary" style={{ display: 'block', textAlign: 'center', textDecoration: 'none' }}>
              {ta('Torna al login')}
            </Link>
          </>
        ) : success ? (
          <>
            <h2>{ta('Password aggiornata')}</h2>
            <p className="modal-subtitle">{ta('Ora puoi accedere con la nuova password.')}</p>
            <Link to="/admin" className="btn btn-primary" style={{ display: 'block', textAlign: 'center', textDecoration: 'none' }}>
              {ta('Vai al login')}
            </Link>
          </>
        ) : (
          <>
            <h2>{ta('Imposta una nuova password')}</h2>
            <p className="modal-subtitle">{ta('Scegli una nuova password per il tuo account amministratore.')}</p>
            {error && <div className="form-error">{error}</div>}
            <form onSubmit={handleSubmit}>
              <div className="field">
                <label htmlFor="new-password">{ta('Nuova password')}</label>
                <input
                  id="new-password"
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  autoComplete="new-password"
                />
              </div>
              <div className="field">
                <label htmlFor="confirm-password">{ta('Conferma nuova password')}</label>
                <input
                  id="confirm-password"
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  autoComplete="new-password"
                />
              </div>
              <button className="btn btn-primary" disabled={submitting}>
                {submitting ? ta('Aggiornamento…') : ta('Imposta nuova password')}
              </button>
            </form>
          </>
        )}

        <p className="security-note">{ta('CONNESSIONE CIFRATA · SESSIONE PROTETTA')}</p>
      </div>
    </div>
  );
}
